import { useNewCode } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { BodyText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { ScheduleWithAContactProvider } from 'features/contacts/schedule_with_a_contact/schedule-with-a-contact-provider'

import { SCHEDULE_WITH_CONTACT_PROVIDER } from '../constants'
import { currentContactProfileSelector } from '../selectors'
import { PromptBlueBox, CalendarIconImage, ItalicText } from './styles'

export const EmptyMeetingHistory = () => {
  const currentContact = useSelector(currentContactProfileSelector)
  const [isShareStarted, setIsShareStarted] = useState(false)
  const [sharedContact, setIsSharedContact] = useState(null)
  const isButtonsExperimentEnabled = useNewCode('org_expansion_share_cta_feature')?.enabled
  const buttonCopy = isButtonsExperimentEnabled ? I18n.t('publisher.contacts.buttons.book_meeting')
    : I18n.t('publisher.contacts.buttons.create_event')

  const showForDesktop = useDeviceType('isDesktopUp')

  return (
    <div>
      <PromptBlueBox>
        <CalendarIconImage />
        {showForDesktop && <BodyText weight="bold">{I18n.t('publisher.contacts.profile.get_started')}</BodyText>}
        <ItalicText size="small">{I18n.t('publisher.contacts.profile.no_history')}</ItalicText>
        {showForDesktop && (
        <Button
          spacingTop="20"
          onClick={() => {
            setIsSharedContact(currentContact)
            setIsShareStarted(true)
          }}
        >
          {buttonCopy}
        </Button>
        )}
      </PromptBlueBox>
      <ScheduleWithAContactProvider
        isFlowStarted={isShareStarted}
        contact={sharedContact}
        onFlowFinish={() => {
          setIsShareStarted(false)
          setIsSharedContact(null)
        }}
        parentSource={SCHEDULE_WITH_CONTACT_PROVIDER.PARENT_COMPONENT.CONTACT_PROFILE}
      />
    </div>
  )
}
